import {range} from '../../../../helpers/util';
import {IIpSubnetCalculatorState} from './models/ip-subnet-calculator.state';

export const SUBNET_MASKS = [
  '0.0.0.0',
  '128.0.0.0',
  '192.0.0.0',
  '224.0.0.0',
  '240.0.0.0',
  '248.0.0.0',
  '252.0.0.0',
  '254.0.0.0',
  '255.0.0.0',
  '255.128.0.0',
  '255.192.0.0',
  '255.224.0.0',
  '255.240.0.0',
  '255.248.0.0',
  '255.252.0.0',
  '255.254.0.0',
  '255.255.0.0',
  '255.255.128.0',
  '255.255.192.0',
  '255.255.224.0',
  '255.255.240.0',
  '255.255.248.0',
  '255.255.252.0',
  '255.255.254.0',
  '255.255.255.0',
  '255.255.255.128',
  '255.255.255.192',
  '255.255.255.224',
  '255.255.255.240',
  '255.255.255.248',
  '255.255.255.252',
];

type subnetMasksMappingOptions = {
  [key: number]: string;
};

export const SUBNET_MASKS_MAPPING: subnetMasksMappingOptions = {
  0: '0.0.0.0',
  1: '128.0.0.0',
  2: '192.0.0.0',
  3: '224.0.0.0',
  4: '240.0.0.0',
  5: '248.0.0.0',
  6: '252.0.0.0',
  7: '254.0.0.0',
  8: '255.0.0.0',
  9: '255.128.0.0',
  10: '255.192.0.0',
  11: '255.224.0.0',
  12: '255.240.0.0',
  13: '255.248.0.0',
  14: '255.252.0.0',
  15: '255.254.0.0',
  16: '255.255.0.0',
  17: '255.255.128.0',
  18: '255.255.192.0',
  19: '255.255.224.0',
  20: '255.255.240.0',
  21: '255.255.248.0',
  22: '255.255.252.0',
  23: '255.255.254.0',
  24: '255.255.255.0',
  25: '255.255.255.128',
  26: '255.255.255.192',
  27: '255.255.255.224',
  28: '255.255.255.240',
  29: '255.255.255.248',
  30: '255.255.255.252',
  31: '255.255.255.254',
  32: '255.255.255.255',
};

export const MASK_BITS = range(0, 30);

export const MAX_SUBNETS = [
  1073741824, 536870912, 268435456, 134217728, 67108864, 33554432, 16777216, 8388608, 4194304,
  2097152, 1048576, 524288, 262144, 131072, 65536, 32768, 16384, 8192, 4096, 2048, 1024, 512, 256,
  128, 64, 32, 16, 8, 4, 2, 1,
];

export const MAX_ADDRESSES = [
  4294967294, 2147483646, 1073741822, 536870910, 268435454, 134217726, 67108862, 33554430, 16777214,
  8388606, 4194302, 2097150, 1048574, 524286, 262142, 131070, 65534, 32766, 16382, 8190, 4094, 2046,
  1022, 510, 254, 126, 62, 30, 14, 6, 2,
];

export const DEFAULT_SUBNET_VALUES: IIpSubnetCalculatorState = {
  broadCastAddress: '10.255.255.255',
  hostAddressRange: '10.0.0.1 - 10.255.255.254',
  ipAddress: '10.0.0.1',
  subnetBitmap: 'ssssssss.hhhhhhhh.hhhhhhhh.hhhhhhhh',
  subnetId: '10.0.0.0',
  wildcardMask: '0.255.255.255',
  hexIp: '0A.00.00.1',
  ipSubnetConst: {
    hostsPerSubnet: 16777214,
    maskBits: 8,
    maximumSubnets: 256,
    subnetBits: 8,
    subnetMask: '255.0.0.0',
  },
};
